import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { nanoid } from "nanoid";

const CaltexRadio = (props) => {
    return (
        <FormControl>
            <RadioGroup defaultValue={props.options[0]} onChange={props.onChange}>
                {props.options && props.options.length > 0
                    ? props.options.map((option) => (
                          <FormControlLabel value={option} control={<Radio />} label={option} key={nanoid()}/>
                      ))
                    : null}
            </RadioGroup>
        </FormControl>
    );
};

export default CaltexRadio;
